module.exports = __webpack_public_path__ + "static/media/มะเส็ง.fb88f925.jpg";